import styled from "@emotion/styled";

export const Container = styled.div`
  padding: 0px;
`;

export const Header = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: #666;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
`;

export const StatCard = styled.div<{ color?: string }>`
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 16px;
  border-left: 4px solid ${(props) => props.color || "#ff4d4f"};
`;

export const StatIcon = styled.div<{ color?: string; bgColor?: string }>`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: ${(props) => props.bgColor || "#fff1f0"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color || "#ff4d4f"};
`;

export const StatInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
`;

export const StatLabel = styled.div`
  font-size: 13px;
  color: #8c8c8c;
  margin-top: 2px;
`;

export const FilterSection = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 180px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: #595959;
`;

export const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  &:focus {
    border-color: #ff4d4f;
  }
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  &:focus {
    border-color: #ff4d4f;
  }
`;

export const TableWrapper = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const TableHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TableTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
`;

export const ExportButton = styled.button`
  background: #ff4d4f;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
  &:hover {
    background: #ff7875;
  }
`;

export const StatusPill = styled.span<{ bg?: string; color?: string }>`
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  background: ${(props) => props.bg || "#f5f5f5"};
  color: ${(props) => props.color || "#595959"};
`;

export const ProfileCard = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0;
  background: transparent;
  border: none;
`;

export const ProfileAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #f3f4f6;
`;

export const ProfileAvatarPlaceholder = styled.div<{
  variant?: "customer" | "store";
}>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  ${(props) =>
    props.variant === "store"
      ? `background: #f0fdfa; color: #0d9488;` // Teal-50
      : `background: #eef2ff; color: #4f46e5;`}// Indigo-50
`;

export const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  justify-content: center;
`;

export const ProfileName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileSubtext = styled.span`
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
`;
